import { useState, React, useEffect } from "react";
import "./Style.scss";
import OtpInput from "react-otp-input";
import PropTypes from "prop-types";
import Swal from "sweetalert2";
import { Box } from "@mui/material";
import {
  validateOtpAuthenticator,
  generateQRCode2FA,
  generateSecret,
  update2FAType,
} from "api/api_register2FA";
import { clearLocalStorage } from "utils/storage";

function Register2FAScanQR({ authenType }) {
  const [otp, setOTP] = useState("");
  const { authenTypeName } = authenType;
  const [qrCodeDataUri, setQrCodeDataUri] = useState("");
  const [secretKey, setSecretKey] = useState("");
  const user = JSON.parse(localStorage.getItem("user"));

  const update2FA = async (typeFA) => {
    await update2FAType(user.username, typeFA);
  };

  const generateQrCode = async () => {
    const secret = await generateSecret();
    setSecretKey(secret);
    const qrcode = await generateQRCode2FA(user.username, secret);
    setQrCodeDataUri(qrcode);
  };
  useEffect(() => {
    generateQrCode();
  }, []);

  const handleOTP = async () => {
    const data = await validateOtpAuthenticator(secretKey, otp, user.username);
    // eslint-disable-next-line no-console
    console.log("data", data);
    if (data) {
      update2FA(authenTypeName === "GGA" ? 3 : 4);
      Swal.fire({
        title: "Xác minh 2 bước đã được bật",
        icon: "success",
      });
      setTimeout(() => {
        clearLocalStorage();
        window.location.href = "/authentication/sign-in";
      }, 1500);
    } else {
      Swal.fire({
        title: "Mã không chính xác hoặc đã hết hạn",
        icon: "error",
      });
    }
  };
  return (
    <Box className="form-container" textAlign="justify">
      <div className="fs-20 fw-700 text-center">Vui lòng quét QR và nhập mã xác thực</div>
      <Box className="fs-14 w-100">1. Tải ứng dụng Authenticator</Box>
      <Box className="fs-14 w-100">2. Trong ứng dụng chọn thiết lập tài khoản</Box>
      <Box className="fs-14 w-100">3. Chọn quét mã QR</Box>
      <Box className="fs-14 w-100">4. Nhập mã Authenticator từ ứng dụng và chọn Xác Thực</Box>
      <Box className="w-100 flex-column centered">
        <img className="profile-image" src={qrCodeDataUri} alt="qr" />
      </Box>
      <Box className="w-100">
        <Box className="fs-14">Mã Authenticator</Box>
        <OtpInput
          onChange={(e) => setOTP(e)}
          value={otp}
          numInputs={6}
          separator={<span> </span>}
          isInputNum
          shouldAutoFocus
          inputStyle="inputStyle1"
          containerStyle="containOTP1"
        />
      </Box>
      <Box
        className="centered fs-14"
        style={{
          width: "40%",
          height: "36px",
          background: "var(--blue-blue-100)",
          borderRadius: "6px",
          color: "white",
          cursor: "pointer",
          marginTop: "20px",
          float: "right",
        }}
        role="button"
        tabIndex="0"
        onClick={handleOTP}
        onKeyDown={() => {}}
      >
        Tiếp theo
      </Box>
    </Box>
  );
}
Register2FAScanQR.propTypes = {
  authenType: PropTypes.objectOf(PropTypes).isRequired,
};
export default Register2FAScanQR;
